import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DrawerModule } from 'primeng/drawer';
import { TagModule } from 'primeng/tag';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { BASE_IMPORTS, BaseComponent } from '../../shared/components/base-component/base-component';
import { StatusTagSeverity } from '../../shared/services/severity.service';
import { SafeAny } from '../../shared/types/safe-any';

@Component({
  standalone: true,
  selector: 'app-header',
  imports: [ButtonModule, BASE_IMPORTS, DrawerModule, ToggleSwitchModule, CardModule, TagModule],
  template: `
    <div class="w-full">
      <p-drawer
        [(visible)]="showNotification"
        [header]="'notifications.title' | translate"
        position="right"
        [style]="drawerStyle"
      >
        <div class="flex justify-between items-center">
          <p-button
            [label]="'notifications.mark-all-as-read' | translate"
            icon="pi pi-check"
            text
          />
          <div class="flex items-center gap-2">
            <p-toggleswitch [(ngModel)]="readStatus" />
            <span>{{ 'notifications.to-read' | translate }}</span>
          </div>
        </div>
        <div class="flex flex-col w-full h-full">
          @for (notification of notifications; track notification.title) {
            <p-card
              [header]="notification.title"
              [style]="{
                boxShadow: 'none',
                borderBottom: '1px solid #e0e0e0',
                borderRadius: '0px',
                backgroundColor: notification.read
                  ? 'var(--surface-ground)'
                  : 'var(--surface-card)',
              }"
            >
              <p class="m-0">{{ notification.message }}</p>
              <span class="text-sm text-gray-500">{{ notification.date }}</span>
            </p-card>
          }
        </div>
      </p-drawer>
      <div class="w-full flex justify-start items-center">
        @if (layoutService.isTabletWidth()) {
          <p-button
            icon="pi pi-bars"
            class="p-button-text layout-menu-button"
            text
            (onClick)="layoutService.onMenuToggle()"
          />
        }
      </div>
      @if (layoutService.showBackButton().value) {
        <p-button
          [label]="'common.back' | translate"
          icon="pi pi-arrow-left"
          size="large"
          severity="contrast"
          (onClick)="goBack()"
        />
      }
      @if (layoutService.titleKey().value) {
        <div class="w-full flex justify-between items-center mt-2 mb-2">
          <div class="w-2/3">
            <h2>
              {{ layoutService.titleKey().title | translate
              }}{{ layoutService.titleKey().titleSuffix || '' }}
            </h2>
          </div>
          <div class="flex justify-end items-center w-1/3 gap-2">
            @if (layoutService.showCustomButton().value) {
              <p-button
                [severity]="layoutService.showCustomButton().severity"
                (click)="layoutService.showCustomButton().onClick()"
                icon="pi pi-plus"
                fluid
                [iconPos]="layoutService.showCustomButton().iconPos"
                [label]="layoutService.showCustomButton().label | translate"
              />
            }
            <div class="header-actions-end">
              @if (layoutService.statusTag().value && layoutService.statusTag().label) {
                <p-tag
                  class="header-status-tag"
                  [value]="layoutService.statusTag().label! | translate"
                  [severity]="statusTagSeverity"
                />
              }
              @if (layoutService.showCloseButton().value) {
                <p-button severity="help" (click)="goClose()" icon="pi pi-times" />
              }
            </div>
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .header-actions-end {
        display: inline-flex;
        align-items: stretch;
        gap: 0.5rem;
      }

      :host ::ng-deep .header-status-tag.p-tag {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        font-size: 1rem;
        font-weight: 600;
        padding: 10px 25px !important;
        border-radius: 0 !important;
      }
    `,
  ],
})
export class AppHeader extends BaseComponent {
  showNotification: boolean = false;
  drawerStyle: SafeAny = {
    width: '25%',
    borderTopLeftRadius: '20px',
    borderBottomLeftRadius: '20px',
  };
  readStatus: boolean = false;
  notifications = [
    {
      title: 'Notifica 1',
      message: 'Questa è una notifica di esempio',
      date: '2021-01-01',
      read: false,
    },
    {
      title: 'Notifica 2',
      message: 'Questa è un',
      date: '2021-01-01',
      read: true,
    },
    {
      title: 'Notifica 3',
      message: 'Questa è una notifica di esempio',
      date: '2021-01-01',
      read: true,
    },
  ];

  constructor() {
    super();
  }

  get statusTagSeverity(): StatusTagSeverity | null | undefined {
    return this.layoutService.statusTag().severity;
  }

  goBack(): void {
    this.router.navigate([this.layoutService.showBackButton().route]);
  }

  goClose(): void {
    const closeButton = this.layoutService.showCloseButton();
    if (closeButton.useBack) {
      this.location.back();
      return;
    }

    if (closeButton.route) {
      this.router.navigate([closeButton.route]);
    }
  }
}
